import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import type { StatusDefinition } from '@/models/StatusDefinitionModel';

/**
 * Hardcoded request-status definitions.
 * This is a temporary stand-in until the unified Status API is ready.
 * It is consumed by RequestForm, RequestEdit, and ClockDoneModal.
 */
export const useRequestStatusStore = defineStore('requestStatus', () => {
    const statuses = ref<StatusDefinition[]>([
        { Id: 1, Value: 0, Label: 'Not Started', Category: 'Request', IsActive: true, IsRefActive: true, SortOrder: 0 },
        { Id: 2, Value: 1, Label: 'In Progress', Category: 'Request', IsActive: true, IsRefActive: true, SortOrder: 1 },
        { Id: 3, Value: 2, Label: 'Completed', Category: 'Request', IsActive: true, IsRefActive: false, SortOrder: 2 },
        { Id: 4, Value: 3, Label: 'Declined', Category: 'Request', IsActive: true, IsRefActive: false, SortOrder: 3 },
        { Id: 5, Value: 4, Label: 'On Hold', Category: 'Request', IsActive: true, IsRefActive: true, SortOrder: 4 }
    ]);

    const options = computed(() => statuses.value.map(s => ({ label: s.Label, value: s.Value })));

    const getByLabel = (label: string) => statuses.value.find(s => s.Label === label);
    const getByValue = (value: number) => statuses.value.find(s => s.Value === value);

    const notStartedValue = computed(() => getByLabel('Not Started')?.Value ?? 0);
    const inProgressValue = computed(() => getByLabel('In Progress')?.Value ?? 1);
    const completedValue = computed(() => getByLabel('Completed')?.Value ?? 3);
    const onHoldValue = computed(() => getByLabel('On Hold')?.Value ?? 4);
    const declinedValue = computed(() => getByLabel('Declined')?.Value ?? 6);

    return {
        statuses,
        options,
        getByLabel,
        getByValue,
        notStartedValue,
        inProgressValue,
        completedValue,
        onHoldValue,
        declinedValue
    };
});
